<template>
  <div id="container" class="cart_st">
    <!-- 약관 동의 START-->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{
              $t('views.member.seller.sellerstep1.6185')
            }}</span>
          </router-link>
        </div>
        <div class="box_wrap" data-detail="saler_agreement">
          <div class="cart_progress">
            <div class="progress_box active">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep1.1880')
                }}</span
                >{{ $t('views.member.seller.sellerstep1.5634') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep1.9110')
                }}</span
                >{{ $t('views.member.seller.sellerstep1.4477') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep1.9003')
                }}</span
                >{{ $t('views.member.seller.sellerstep1.4041') }}
              </p>
            </div>
          </div>

          <div class="box">
            <div class="box_title">
              <h2>{{ $t('views.member.seller.sellerstep1.2293') }}</h2>
              <p class="guide_txt">
                {{ $t('views.member.seller.sellerstep1.2869') }}
              </p>
            </div>

            <div class="text_wrap">
              <dl>
                <dt>{{ $t('views.member.seller.sellerstep1.9093') }}</dt>
                <dd>{{ $t('views.member.seller.sellerstep1.1012') }}</dd>
                <dt>{{ $t('views.member.seller.sellerstep1.8883') }}</dt>
                <dd>{{ $t('views.member.seller.sellerstep1.6233') }}</dd>
                <dt>{{ $t('views.member.seller.sellerstep1.4084') }}</dt>
                <dd>{{ $t('views.member.seller.sellerstep1.4873') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.351') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.8174') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.5368') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.2024') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.224') }}</dd>
                <dd>{{ $t('views.member.seller.sellerstep1.8484') }}</dd>
              </dl>
            </div>

            <div class="join_check">
              <div class="text_label">
                <label
                  ><input
                    v-model="agreedToTerms"
                    type="checkbox"
                    name="agreeTerms"
                    class="chk_agree"
                  /><em></em
                  ><span>{{
                    $t('views.member.seller.sellerstep1.2547')
                  }}</span></label
                >
              </div>
            </div>

            <div class="btn_wrap" data-detail="btn_bottom">
              <router-link :to="{ name: 'orders' }" class="box_btn dull">
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </router-link>

              <button
                :class="{ dull: !agreedToTerms }"
                class="box_btn"
                :disabled="!agreedToTerms"
                @click="goToStep2"
              >
                <span class="an_t">{{ $t('library.deletemodal.next') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 약관 동의 END-->
  </div>
</template>

<script>
export default {
  name: 'SellerStep1',

  data() {
    return {
      agreedToTerms: false
    }
  },

  methods: {
    goToStep2() {
      if (this.agreedToTerms) {
        this.$router.push({ name: 'seller_step2' })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
